import type { FilesProxySchemaWithId } from '@iconik-io/iconik-api/src/services/files';

import ContextMenu from '../../components/context_menu/context_menu';
import contextMenuConnector from '../../components/context_menu/context_menu_connector';
import type {
  ContextMenuItemDefinition,
  GetDefinition,
} from '../../components/context_menu/types';
import {
  FORMATS_PANEL_DELETE_PROXY,
  FORMATS_PANEL_METADATA_MODAL,
} from '../../constants/modals';
import {
  CONTEXT_MENU_PANELS_FILES_PROXY,
  connectContextMenuConsumer,
} from '../../contexts/context_menu';
import { downloadProxyById } from '../../ducks/files/thunks';
import { openModal } from '../../ducks/modals_manager/slice';
import { ICONS } from '../../icons/icon';
import type { AppDispatch } from '../../store/types';
import separateMenuGroups from '../../utils/separate_menu_groups';
import { selectResolvedPermissions } from './selectors';

export const getDefinition: GetDefinition<FilesProxySchemaWithId> = (
  props,
  state,
) => {
  const contextItems = props.contextItems;
  const [contextItem] = contextItems;

  const itemsMain: ContextMenuItemDefinition[] = [];
  const itemsDelete: ContextMenuItemDefinition[] = [];

  if (!contextItem) {
    return { items: itemsMain };
  }

  const { userRoles } = state.rolesReducer;
  const { asset_id: assetId } = contextItem;
  const proxyAsset = assetId ? state.entities.assets[assetId] : undefined;
  // proxyAsset is dereferenced below, so a proxy with no resolvable asset has
  // no menu rather than a crash.
  if (!assetId || !proxyAsset) {
    return { items: itemsMain };
  }
  const permissions = selectResolvedPermissions(state, assetId);

  if (contextItem.status === 'DELETED') {
    return {
      items: itemsMain,
    };
  }

  itemsMain.push({
    label: 'See Metadata',
    action: () => (dispatch: AppDispatch) => {
      dispatch(
        openModal({
          id: FORMATS_PANEL_METADATA_MODAL,
          contextItems: [
            { name: 'PROXY', id: contextItem.id, metadata: [contextItem] },
          ],
        }),
      );
    },
    icon: ICONS.Metadata,
  });

  if (userRoles.webCanDownloadProxy) {
    itemsMain.push({
      label: 'Download',
      action: () => (dispatch: AppDispatch) => {
        dispatch(downloadProxyById(assetId, contextItem.id));
      },
      icon: ICONS.Download,
      disabled: proxyAsset.is_blocked,
    });
  }

  // delete proxies has specific roles
  const deletePermission = userRoles.canDeleteProxies;

  if (deletePermission && permissions.write) {
    itemsDelete.push({
      label: 'Delete…',
      action: () => (dispatch: AppDispatch) => {
        dispatch(
          openModal({
            id: FORMATS_PANEL_DELETE_PROXY,
            contextItems,
          }),
        );
      },
      icon: ICONS.TrashBin,
    });
  }

  return {
    items: separateMenuGroups([itemsMain, itemsDelete]),
  };
};

const FormatsPanelContextMenu = connectContextMenuConsumer(
  contextMenuConnector(getDefinition)(ContextMenu),
  CONTEXT_MENU_PANELS_FILES_PROXY,
);

export default FormatsPanelContextMenu;
